import Home from "../components/Home/Home.jsx";

function HomePage({ cta = "signup" }) {
  return (
    <div className="container">
      <Home cta={cta} />
    </div>
  );
}

export default HomePage;
